import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import components50cm from "./components/50cm";
import components1m from "./components/1m";
import components2m from "./components/2m";
import components4m from "./components/4m";
import components8m from "./components/8m";
import components16m from "./components/16m";
import components32m from "./components/32m";

const principle: Slide = {
  description:
    "It is proposed here to listen to a source according to the distance. Note that the amplitude decreases and that a listening with a normalized level is also proposed to better apprehend the effect of dissipation, effect that can also be visualized on the spectra.",
  theory: theory,
  layout: {
    type: "slidersToggle",
    options: {
      labels: [
        [
          { name: "50 cm" },
          { name: "1 m" },
          { name: "2 m" },
          { name: "4 m" },
          { name: "8 m" },
          { name: "16 m" },
          { name: "32 m" },
        ],
      ],
      controlsPosition: "bottom",
      components: [
        components50cm,
        components1m,
        components2m,
        components4m,
        components8m,
        components16m,
        components32m,
      ],
    },
  },
};

export default principle;
